<ng-container>
  <dls-dialog-content [ngClass]="{'heightAdjust': additionalStyles.heightAdjust,'paddingZero': additionalStyles.paddingZero}">
    <section class="dynamic-modal-content-container">
      <span class="dynamic-modal-content Auto_Popup_Text" *ngIf="content">{{content | translate:contentParams}}</span>
      <div class="dynamic-modal-content">
        <ng-template class="target-element" #target></ng-template>
      </div>
    </section>
  </dls-dialog-content>
  <dls-dialog-footer class="modal-buttons-section" *ngIf="buttons.declineBtn || buttons.approveBtn || buttons.actionBtn">
    <gen-button class="Auto_Popup_Cancel_Button"
                *ngIf="buttons.declineBtn"
                (click)="cancelActionEmitter({status:2})"
                [type]="'quite'"
                [text]="buttons.declineBtn"></gen-button>
    <gen-button class="Auto_Popup_Submit_Button" *ngIf="buttons.approveBtn"
                (click)="actionEmitter(1)"
                [type]="'primary'"
                [text]="buttons.approveBtn"
                [disabled]="approveBtnIsDisabled$() | async"
                [btnClasses]="'Auto_Button_primary gen-button-element primary__button Auto_Button_Submit'"></gen-button>
    <gen-button class="modal-action Auto_Popup_Action_Button" *ngIf="buttons.actionBtn"
                (click)="actionEmitter({status:3})"
                [type]="'quite'"
                [text]="buttons.actionBtn"
                [iconClass]="actionIcon"></gen-button>
  </dls-dialog-footer>
</ng-container>
